import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import './SmartDrillAISettings.css';

function SmartDrillAISettings() {
  const [settings, setSettings] = useState({
    practiceApproach: '',
    timer: '',
    screenType: '',
    practiceMedium: '',
    baseLanguage: 'English',
    pitch: 1.0,
    speed: 1.0,
    volume: 1.0,
    aiSpeechToText: '',
    cloudStorage: '',
    personalCloud: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value
    }));
  };

  const handleSave = () => {
    // console.log('Settings saved:', settings);
    // Handle saving logic here
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mb-8 mx-8 border-b border-b-gray-300 text-white'>Smart Drill - Settings</h2>
      </div>
      <div className="main-content">
        <div className="settings-section">
          <h3>Practice Approach</h3>
          <div>
            <input type="radio" id="viewWrite" name="practiceApproach" value="View & Write" onChange={handleChange} />
            <label htmlFor="viewWrite">View & Write</label>
            <input type="radio" id="listenWrite" name="practiceApproach" value="Listen & Write" onChange={handleChange} />
            <label htmlFor="listenWrite">Listen & Write</label>
            <input type="radio" id="viewListenWrite" name="practiceApproach" value="View, Listen & Write" onChange={handleChange} />
            <label htmlFor="viewListenWrite">View, Listen & Write</label>
          </div>
        </div>

        <div className="settings-section">
          <h3>Timer</h3>
          <div>
            <input type="radio" id="countUp" name="timer" value="Count Up Timer" onChange={handleChange} />
            <label htmlFor="countUp">Count Up Timer</label>
            <input type="radio" id="countDown" name="timer" value="Count Down Timer" onChange={handleChange} />
            <label htmlFor="countDown">Count Down Timer</label>
          </div>
        </div>

        <div className="settings-section">
          <h3>Screen Type</h3>
          <div>
            <input type="radio" id="smartTV" name="screenType" value="Smart TV" onChange={handleChange} />
            <label htmlFor="smartTV">Smart TV</label>
            <input type="radio" id="mobile" name="screenType" value="Mobile" onChange={handleChange} />
            <label htmlFor="mobile">Mobile</label>
            <input type="radio" id="tab" name="screenType" value="Tab" onChange={handleChange} />
            <label htmlFor="tab">Tab</label>
            <input type="radio" id="desktopLaptop" name="screenType" value="Desktop/Laptop" onChange={handleChange} />
            <label htmlFor="desktopLaptop">Desktop/Laptop</label>
          </div>
        </div>

        <div className="settings-section">
          <h3>Practice Medium</h3>
          <div>
            <input type="radio" id="reusableSheet" name="practiceMedium" value="Reusable Sheet" onChange={handleChange} />
            <label htmlFor="reusableSheet">Reusable Sheet</label>
            <input type="radio" id="plainPaper" name="practiceMedium" value="Plain Paper" onChange={handleChange} />
            <label htmlFor="plainPaper">Plain Paper</label>
            <input type="radio" id="noneMind" name="practiceMedium" value="None/Mind" onChange={handleChange} />
            <label htmlFor="noneMind">None/Mind</label>
          </div>
        </div>

        <div className="settings-section">
          <h3>Base Speech To Text</h3>
          <div>
            <label htmlFor="baseLanguage">Language:</label>
            <select id="baseLanguage" name="baseLanguage" value={settings.baseLanguage} onChange={handleChange}>
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
              <option value="Marathi">Marathi</option>
              <option value="Gujarati">Gujarati</option>
              <option value="Punjabi">Punjabi</option>
              <option value="Urdu">Urdu</option>
              <option value="Tamil">Tamil</option>
              <option value="Telugu">Telugu</option>
              <option value="Kannada">Kannada</option>
              <option value="Malayalam">Malayalam</option>
              <option value="Arabic">Arabic</option>
              <option value="Bengali">Bengali</option>
              <option value="Spanish">Spanish</option>
              <option value="Chinese">Chinese</option>
              <option value="Japanese">Japanese</option>
            </select>
          </div>
          <div>
            <label htmlFor="pitch">Pitch:</label>
            <input type="range" id="pitch" name="pitch" min="0.5" max="2.0" step="0.1" value={settings.pitch} onChange={handleChange} />
            <span>{settings.pitch}</span>
          </div>
          <div>
            <label htmlFor="speed">Speed:</label>
            <input type="range" id="speed" name="speed" min="0.5" max="3.0" step="0.1" value={settings.speed} onChange={handleChange} />
            <span>{settings.speed}</span>
          </div>
          <div>
            <label htmlFor="volume">Volume:</label>
            <input type="range" id="volume" name="volume" min="0.1" max="1.0" step="0.1" value={settings.volume} onChange={handleChange} />
            <span>{settings.volume}</span>
          </div>
        </div>

        <div className="settings-section">
          <h3>AI Speech To Text</h3>
          <div>
            <input type="radio" id="amazonPolly" name="aiSpeechToText" value="Amazon Polly" onChange={handleChange} />
            <label htmlFor="amazonPolly">Amazon Polly</label>
            <input type="radio" id="ibmWatson" name="aiSpeechToText" value="IBM Watson" onChange={handleChange} />
            <label htmlFor="ibmWatson">IBM Watson</label>
            <input type="radio" id="google" name="aiSpeechToText" value="Google" onChange={handleChange} />
            <label htmlFor="google">Google</label>
          </div>
        </div>

        <div className="settings-section">
          <h3>Cloud Storage</h3>
          <div className="text-black">
            <input type="radio" id="personalCloud" name="cloudStorage" value="Personal Cloud" onChange={handleChange} />
            <label htmlFor="personalCloud">Personal Cloud</label>
            {settings.cloudStorage === 'Personal Cloud' && (
              <div className="sub-section text-black">
                <input type="radio" id="googleDrive" name="personalCloud" value="Google Drive" onChange={handleChange} />
                <label htmlFor="googleDrive">Google Drive</label>
                <input type="radio" id="oneDrive" name="personalCloud" value="OneDrive" onChange={handleChange} />
                <label htmlFor="oneDrive">OneDrive</label>
                <input type="radio" id="dropBox" name="personalCloud" value="DropBox" onChange={handleChange} />
                <label htmlFor="dropBox">DropBox</label>
              </div>
            )}
            <input type="radio" id="think5WhysCloud" name="cloudStorage" value="Think5Whys Cloud" onChange={handleChange} />
            <label htmlFor="think5WhysCloud">Think5Whys Cloud</label>
            <input type="radio" id="privateCloud" name="cloudStorage" value="Private Cloud" onChange={handleChange} />
            <label htmlFor="privateCloud">Private Cloud</label>
            <input type="radio" id="governmentCloud" name="cloudStorage" value="Government Cloud" onChange={handleChange} />
            <label htmlFor="governmentCloud">Government Cloud</label>
          </div>
        </div>

        <button className="save-button" onClick={handleSave}>Save Settings</button>
      </div>
    </MainLayout>
  );
}

export default SmartDrillAISettings;
